<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button v-if="backRole('PM_1')" type="primary" @click="startCreate()" size="mini">项目申请</el-button>
      </div>
      <el-row>
        <el-col class="item-select" :span="5">
          <label>项目状态：</label>
          <el-select size="mini" v-model="filterStatus" placeholder="请选择">
            <el-option v-for="item in statusArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col>
        <el-col class="item-select" :span="5">
          <label>项目组：</label>
          <el-select size="mini" v-model="teamId" placeholder="请选择">
            <el-option v-for="item in teamArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col class="item-input" :span="8">
          <label>搜索：</label>
          <el-input v-model="filterKey" size="mini" placeholder="你可以搜索项目编号/立项编号/项目名/负责人"></el-input>
        </el-col>
      </el-row>
    </div>

    <el-table :data="paginationData" :span-method="objectSpanMethod" border style="width: 100%" v-loading="loading">
      <el-table-column prop="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="number" label="项目编号" width="100px">
      </el-table-column>
      <el-table-column label="工程名称">
        <template slot-scope="scope">
          <span v-if="scope.row.ctype" class="title-z">{{scope.row.ctype}}</span>
          <span v-if="scope.row.type==3" class="title-z wx">微型</span>
          <router-link class="table-link" :to="'/Project/Detail/' + scope.row.id" target="_blank">{{scope.row.name}}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="deptName" label="所属公司" width="170px">
      </el-table-column>
      <el-table-column prop="status" label="项目状态" width="100px">
      </el-table-column>
      <el-table-column label="项目负责人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.leader'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <router-link target="_blank" :to="'/Project/Detail/' + scope.row.id">
            <el-button plain size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  
  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        teamId: 0,
        filterKey: "",
        teamArr: [],
        filterStatus: "全部",
        statusArr: ["全部", "申请中", "申请完成", "立项完成", "招标中", "招标完成", "签订合同中", "实施中", "已完成"],
      }
    },
    mounted() {
      this.getLists()
      // 获取项目组
      this.getTeam()
    },
    methods: {
      // 合并行列
      objectSpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex === 0) {
          if (row.rowspan != undefined) {
            if (row.rowspan > 0) {
              return [row.rowspan + 1, 1]
            }
          } else {
            return [0, 0]
          }
        }
      },
      // 获取项目组
      getTeam() {
        ajax.post('/gc/project/team/list', '', (res) => {
          this.teamArr = [{
            id: 0,
            name: "全部"
          }]
          this.teamArr = this.teamArr.concat(res.vo.array)
        })
      },
      startCreate() {
        this.$router.push("/Project/Create")
      },
      projectDetail(row) {
        this.$router.push("/Project/Detail/" + row.id)
      },
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterStatus != "全部" || this.teamId || this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _project = this.listData[i]

            // 筛选状态
            let _filterStatus = true
            if (this.filterStatus != "全部") {
              if (this.filterStatus != _project.status) {
                _filterStatus = false
              }
            }
            console.log(_filterStatus && _filterTeam)


            // 筛选项目组
            let _filterTeam = true
            if (this.teamId && _project.team && _project.team.id != this.teamId) {
              _filterTeam = false
            }
            if (this.teamId && !_project.team) {
              _filterTeam = false
            }

            if (_filterStatus && _filterTeam) {
              if (_project.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _project.leader.name.toLowerCase()
                .indexOf(this.filterKey.toLowerCase()) != -1 ||
                _project.number.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
                this.filterData.push(_project)
              }
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        let paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
        // 拆分子项目
        this.paginationData = []
        for (var i = 0; i < paginationData.length; i++) {
          let _item = paginationData[i]
          _item.rowspan = _item.childs.length
          _item.index = i + 1
          // push进去父项目
          this.paginationData.push(_item)

          if (_item.rowspan > 0) {
            // console.log(_item.rowspan)
            // push进去子项目
            for (var j = 0; j < _item.childs.length; j++) {
              // _item.childs[j].rowspan = 0
              this.paginationData.push(_item.childs[j])
            }
          }
        }
      },
      // 获取列表
      getLists() {
        ajax.get('/user/project/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'teamId'() {
        this.getFilterData()
      },
      'filterStatus'() {
        this.getFilterData()
      },
      'filterKey'() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/user/projectlist.vue